import { RootFiIntegration } from '@commenda/prisma';
import { FileBasic } from '@commenda/types/src/file/types';
import { JobEntity, JobOperation, JobStatus } from '../job/types';

export type ICommendaProduct = {
  id: string;
  sku: string;
  name: string;
  description: string;
  taxCode: string;
  sourcePlatform: RootFiIntegration;
  sourcePlatformId: string;
};

export type ICommendaProductTaxCode = {
  code: string;
  description: string;
  additionalInfo: string;
};

type ColumnMapping = {
  fromColumn: string;
  toColumn: string;
};

export interface BulkUploadProps {
  file: FileBasic;
  corporationId: number;
  columnMapping?: ColumnMapping[];
  updateProtectedColumns?: boolean;
}

interface BulkJobResponse {
  id: string;
  org_id: string ;
  corporation_id: string ;
  entity: JobEntity;
  operation: JobOperation;
  status: JobStatus;
  file_name: string;
  failure_reasons: string[] | null;
}

export interface BulkUploadResponse {
  data: {
    job: BulkJobResponse;
  };
  message: string;
}

export type ProductsBulkUpdateFilterProps = {
  corporation_id: number;
  product_ids?: string[];
  excluded_ids?: string[];
  search_term?: string;
  source_platform_id?: string;
  tax_codes?: string[];
};

export type ProductsBulkUpdateFieldsProps = {
  tax_code?: string;
};

export type ProductsBulkUpdateProps = {
  update: ProductsBulkUpdateFieldsProps;
  filters: ProductsBulkUpdateFilterProps;
};

export type ProductsBulkDeleteProps = {
  filters: ProductsBulkUpdateFilterProps;
};

export enum ExportDataDeliveryType {
  EMAIL = 'email',
}

export interface ExportDataDeliveryOptions {
  type: ExportDataDeliveryType;
  recipients?: string[];
}

export interface BulkExportProductsRequest {
  filters: ProductsBulkUpdateFilterProps;
  delivery: ExportDataDeliveryOptions;
}

export interface BulkExportProductsResponse {
  message: string;
}
